module.exports = __webpack_public_path__ + "media/images/google_play_store_resized-d175a2061fa107c1186f1c833fa4801e.png";